import {
  FileExtension,
  FileExtensionMimeType,
  type FileExtensionMimeTypeValues,
  type FileExtensionValues,
} from '@openx/constants/fileExtensions.ts';

export const downloadBlobParts = (
  blobParts: BlobPart | BlobPart[],
  filenamePrefix: string,
  mimeType: FileExtensionMimeTypeValues = FileExtensionMimeType.CSV,
  fileExtension: FileExtensionValues = FileExtension.CSV
) => {
  const data = Array.isArray(blobParts) ? blobParts : [blobParts];
  const blob = new Blob(data, { type: mimeType });
  const fileName = `${filenamePrefix}-${new Date().toISOString().substring(0, 10)}`;
  const link = document.createElement('a');

  link.download = `${fileName}.${fileExtension}`;
  link.href = window.URL.createObjectURL(blob);
  link.click();
  link.remove();
};
